import axios from '../api/axios'

import useAuth from './useAuth'

const useRefreshToken = () => {
  const { url } = document.getElementById('root').dataset || {}
  const { setAuth } = useAuth()

  const refresh = async () => {
    const response = await axios.get(url, {
      withCredentials: true,
    })

    setAuth((prev) => ({ ...prev, accessToken: response.data.access_token }))
    return response.data.access_token
  }
  return refresh
}

export default useRefreshToken
